import { and } from '@lumapps/utils/function/predicate/and';
import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute, matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/EmbeddedMap';
import { EMBEDDED_MAP } from '../../../constants';
import { createEmbeddedMap } from '../../../utils/createEmbeddedMap';

type ElementTypes = typeof EMBEDDED_MAP;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [EMBEDDED_MAP]: {
        type: EMBEDDED_MAP,
        test: and(
            matchNode({ tagName: 'iframe' }),
            matchAttribute('src', /./),
            matchAttribute('className', new RegExp(CLASSNAME)),
        ),
        transform: ({ properties }: any) => {
            return createEmbeddedMap({ url: properties.src, title: properties.title });
        },
    },
};
